
import { Input } from "@workspace/web-ui/components/input"
import { cn } from "@workspace/web-ui/lib/utils"
import { Search } from "lucide-react"


interface SearchInputProps {
    value: string
    setValue: (value: string) => void
    placeholder?: string
    className?: string
}

const SearchInput = ({ value, setValue, placeholder, className }: SearchInputProps) => {
    return (
        <div className="flex items-center sm:gap-2 px-4 py-2 rounded-lg border border-[##ADACB0] w-full md:w-[40%] bg-white">
            <Search className="w-4 h-4 sm:w-5 sm:h-5" />
            <Input
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder={placeholder}
                className={cn("border-none placeholder:text-xs sm:placeholder:text-base  outline-none focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:border-none focus-visible:outline-none", className)}
            />
        </div>
    )
}

export default SearchInput
